if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        /* Somos Crearte - Alinear miniaturas verticales en escritorio */
if (window.innerWidth >= 990 && this.elements.thumbnails) {
  requestAnimationFrame(() => {
    const lista = this.elements.thumbnails.querySelector('.thumbnail-list');

    if (!lista) return;

    const sliderLeft =
      this.elements.thumbnails.getBoundingClientRect().left;

    const listaLeft =
      lista.getBoundingClientRect().left;

    const diferencia = listaLeft - sliderLeft;

    if (Math.abs(diferencia) > 1) {
      lista.style.setProperty(
        'margin-left',
        `${-diferencia}px`,
        'important'
      );
    }
  });
}
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
  const activeMedia = event.detail.currentElement;

  const thumbnail = this.elements.thumbnails.querySelector(
    `[data-target="${activeMedia.dataset.mediaId}"]`
  );

  this.setActiveThumbnail(thumbnail);
  this.playActiveMedia(activeMedia);
}

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
  window.pauseAllMedia();

  const deferredMedia = activeItem.querySelector('deferred-media');
  if (!deferredMedia) return;

  /* Somos Crearte: ocultar reproductor original de Dawn */
  const modalOpener = activeItem.querySelector(
    '.product__modal-opener--video'
  );

  if (modalOpener) {
    modalOpener.style.setProperty('display', 'none', 'important');
  }

  /* Hacer visible el contenedor del video */
  deferredMedia.style.setProperty('display', 'block', 'important');
  deferredMedia.style.setProperty('width', '100%', 'important');

  /* Cargar el video de Dawn */
  deferredMedia.loadContent(false);

  setTimeout(() => {
    const video = deferredMedia.querySelector('video');
    if (!video) return;

    /* Ocultar poster original */
    const poster = deferredMedia.querySelector('.deferred-media__poster');

    if (poster) {
      poster.style.setProperty('display', 'none', 'important');
    }

    /* Siempre silenciado */
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;

    /* Autoplay + loop */
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');

    /* Sin controles */
    video.controls = false;
    video.removeAttribute('controls');

    /* Evitar interacción con el reproductor */
    video.style.pointerEvents = 'none';

    /* Iniciar reproducción */
    video.play().catch(() => {});

    /* Protección adicional */
    if (!video.dataset.somosCrearteVideo) {
      video.dataset.somosCrearteVideo = 'true';

      /* Impedir que pueda activarse el audio */
      video.addEventListener('volumechange', () => {
        if (!video.muted || video.volume !== 0) {
          video.muted = true;
          video.volume = 0;
        }
      });

      /* Reforzar loop si Dawn/navegador lo interrumpe */
      video.addEventListener('ended', () => {
        video.currentTime = 0;
        video.muted = true;
        video.play().catch(() => {});
      });
    }
  }, 500);
}
      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
